export default __webpack_public_path__ + "static/media/roller.0a06b38d.jpg";